module.exports = __webpack_public_path__ + "./fonts/King_Luau.ttf";